import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import KnowledgeBasePage from "../pages/knowledge-base/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/knowledge-base",
    element: <KnowledgeBasePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;